export default __webpack_public_path__ + "static/media/whatsapp.8bd50583.png";